import {ReactNode} from 'react'
import {useMetaValue, UseMetaValueProps} from './useMetaValue'

type RenderFn = (content: ReactNode) => ReactNode

type MetaValueProps = Omit<UseMetaValueProps, 'children'> & {
  children?: RenderFn
  render?: RenderFn
}

export const MetaValue = ({
  ref,
  children,
  render = children,
  ...rest
}: MetaValueProps) => {
  const content = useMetaValue(rest, ref)
  return render ? render(content) : content
}
